import {Dialog, IconButton, Typography} from "@mui/material";
import {KeyboardEvent} from "react";
import './ImageLightbox.scss';
import {ChevronLeftIcon, ChevronRightIcon, CloseIcon} from "./Icons";

export interface LightboxImage {
    src: string,
    alt: string,
}

/** Full-screen preview of one image from `images`; `index === null` means closed. */
function ImageLightbox(props: {images: LightboxImage[], index: number | null, onChange: (index: number | null) => void}) {
    const {images, index, onChange} = props;
    const image = index !== null ? images[index] : undefined;
    const hasMany = images.length > 1;

    const show = (offset: number) => {
        if (index !== null) {
            onChange((index + offset + images.length) % images.length);
        }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (!hasMany) {
            return;
        }
        if (e.key === "ArrowLeft") {
            show(-1);
        } else if (e.key === "ArrowRight") {
            show(1);
        }
    };

    return (
        <Dialog
            open={!!image}
            onClose={() => onChange(null)}
            onKeyDown={handleKeyDown}
            maxWidth={false}
            className="ImageLightbox"
            aria-label={image?.alt}
        >
            <IconButton aria-label="Zamknij podgląd" onClick={() => onChange(null)}
                        className="ImageLightboxButton ImageLightboxClose">
                <CloseIcon/>
            </IconButton>
            {hasMany &&
                <>
                    <IconButton aria-label="Poprzednia grafika" onClick={() => show(-1)}
                                className="ImageLightboxButton ImageLightboxPrev">
                        <ChevronLeftIcon/>
                    </IconButton>
                    <IconButton aria-label="Następna grafika" onClick={() => show(1)}
                                className="ImageLightboxButton ImageLightboxNext">
                        <ChevronRightIcon/>
                    </IconButton>
                </>
            }
            {image && <img src={image.src} alt={image.alt} onClick={() => onChange(null)}/>}
            {hasMany && index !== null &&
                <Typography className="ImageLightboxCaption">{image?.alt} · {index + 1} / {images.length}</Typography>
            }
        </Dialog>
    )
}

export default ImageLightbox;
